import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { AppProvider } from '../hooks/useAppContext'
import { routesDef } from '../config/routes'
import Layout from '../components/layout'
import HomePage from './home'
import NotFoundPage from './NotFound'

export type AppProps = {
  routeContext?: Record<string, any>
}

export default function App({ routeContext }: AppProps) {
  return (
    <AppProvider routeContext={routeContext}>
      <Routes>
        <Route element={<Layout />}>
          <Route path={routesDef.HomePage.path} element={<HomePage />} />
        </Route>
        <Route path={routesDef.NotFound.path} element={<NotFoundPage />} />
      </Routes>
    </AppProvider>
  )
}
